import { Injectable, Injector } from "@angular/core";
import dexFreightMS from "interfaces";
import { environment } from "../environments/environment";
import { AppConfig } from "./app.config";
import { UneteIO } from "./backDebugger";
import { CompanySettingsService } from "./company-settings.service";
import { Subscription } from "rxjs";
import { DataRegistryService } from "./data-registry.service";
import { HTTPProxy } from "./@utils/http-proxies";

@Injectable()
export class Microservices {
  companySettingsService: CompanySettingsService;
  dexFreight: dexFreightMS;
  DexAuth;
  Stats;
  Obs: dexFreightMS;
  Promises: any = {};
  Companies: any;
  Users: any;
  weightUnits: any;
  lengthUnits: any;
  coin: any;

  Modules = {};
  private userSettings: any;
  listeners: Subscription[] = [];

  constructor(private ac: AppConfig, private injector: Injector, private ds: DataRegistryService) {
    this.Obs = UneteIO.socket(environment.srcUrl, environment.inspector? this.ds : null);
    this.DexAuth = this.Obs.Auth;

    this.Companies = {};
    this.Users = {};
  }

  setupListeners() {
    this.companySettingsService = this.injector.get(CompanySettingsService);

    this.listeners.push(
      // THIS EXECUTE A LOT OF TIME
      this.companySettingsService.companySettings.subscribe(res => {
        this.userSettings = res;
        this.getDefaultSettings();
      })
    );
  }

  removeListeners() {
    this.listeners.forEach(listener => listener.unsubscribe());
    this.listeners = [];
  }

  async sendTimeToLoad(module: string, time: number): Promise<void> {
    if (Object.keys(this.Modules).length > 0) {
      let last = Object.keys(this.Modules).slice(-1)[0];
      this.Modules[module] = this.Modules[last] + time;
      let key = Object.keys(this.Modules);
      let value = Object.values(this.Modules);
      let newObj = key.map((v, i) => {
        let previusValue = value[i - 1];
        return {
          event: v,
          totalTime: value[i],
          currentTime: previusValue
            ? Math.abs(
              parseFloat(<string>previusValue) - parseFloat(<string>value[i])
            )
            : value[i],
        };
      });
      // this.dexFreight.Events.registerLoadData(newObj, localStorage.getItem('token'))
    } else {
      this.Modules[module] = time;
    }
  }

  async getCompany(_id: string, token: string = localStorage.getItem("token")) {
    const prefix = "Company:";
    if (this.Companies[_id]) return this.Companies[_id];
    if (this.Promises[prefix + _id]) return await this.Promises[prefix + _id];
    this.Promises[prefix + _id] = dexFreight.Companies.get(_id);
    this.Promises[prefix + _id]
      .then(() => delete this.Promises[prefix + _id])
      .catch(() => delete this.Promises[prefix + _id]);

    return (this.Companies[_id] = await this.Promises[prefix + _id]);
  }
  async getUser(_id: string, token: string = localStorage.getItem("token"), force?: boolean) {
    // return (
    //   this.Users[_id] || (this.Users[_id] = await this.DexAuth.get(_id, token))
    // );

    if (force) delete this.Users[_id];
    const prefix = "User:";
    if (this.Users[_id]) return this.Users[_id];
    if (this.Promises[prefix + _id]) return await this.Promises[prefix + _id];
    this.Promises[prefix + _id] = this.DexAuth.get(_id, token);
    this.Promises[prefix + _id]
      .then(() => delete this.Promises[prefix + _id])
      .catch(() => delete this.Promises[prefix + _id]);

    return (this.Users[_id] = await this.Promises[prefix + _id]);
  }
  /**
     * @param token
     * @returns User settings like language and configurations
     */
  async getUserSettings(token) {
    try {
      return await this.companySettingsService.companySettings.sync();
    } catch (e) {
      console.log(e)
    }
  }

  getDefaultSettings() {
    this.coin = "MXN";
    this.weightUnits = "kg";
    this.lengthUnits = "m";
  }

  get getCurrentSetting() {
    return this.userSettings
  }
}
export const dexFreight = HTTPProxy(environment.srcUrl) as dexFreightMS;
export default dexFreight;
